import type { FaireProductEntity } from "../../entity_types/product";

export const p_b6xusq5r4r: FaireProductEntity = {
  token: "p_b6xusq5r4r",
  type: "product",
  name: "Strawberry - Organic Cotton Jacquard Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1644451f02aac37f9a59cfd5155da3d6b88274bcf004dc3170a7f1e04a474315.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ae46dd1c2912958f7bf37b90ab50eebdf425cd220bd83eedd42d67038f121ae.png",
    "https://cdn.faire.com/fastly/8744e2c6801b5e5ce16b80bc0f2f4b142016f59ee05429f34dfa18132f260109.png",
    "https://cdn.faire.com/fastly/4020b642283470e4c5b4bfeb3facdff2620595fd44ad164aee9943a7cfcb5480.png",
    "https://cdn.faire.com/fastly/75b1cafbf27a5b37750d19bb07cbd2a0b1011c7ef58c03f5137d7410e2e234db.jpeg",
    "https://cdn.faire.com/fastly/6f042147cd2968079792c64a7e7d1d1799b3de1a144db06a9886b7721814a11d.jpeg",
    "https://cdn.faire.com/fastly/59ee0208c312c761734af1a94becb0b183e7e678c7e5d0a7f6ff26c7f7f9368a.jpeg",
  ],
  priceDollars: 26,
  description:
    "Crafted from 100% organic cotton, this jacquard-knit baby blanket offers beautiful texture, generous coverage, and everyday comfort.\n\n• Large size: 30 x 42 inches\n• Ultra-soft, lightweight, breathable, and comfortable for all seasons\n• Made from non-toxic, natural fibers, gentle on sensitive skin\n• Produced using eco-friendly, sustainable materials\n• Made from sustainably grown organic cotton, supporting better livelihoods for small grower farmers\n• Thoughtfully designed in the USA and ethically made in India by skilled artisans\n• Created with care by Viverano, a family-owned small business committed to pure, honest comfort\n\nTimeless design. Responsible materials. Comfort you can feel—and trust.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:30.025Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
